export default class FolderPathDialogController {
    /** @ngInject */
    constructor(DialogService, folderChangedCallback, folderId, EventEmitter) {
        this.DialogService = DialogService;
        this.folderChangedCallback = folderChangedCallback;
        this.originalFolderId = folderId;
        this.folderId = this.originalFolderId;
        this.eventEmitter = EventEmitter;
        if (this.originalFolderId) {
            this.preSelected = [this.originalFolderId];
        }
    }

    onFolderChange({ folderId, dblClicked }) {
        this.folderId = folderId;
        if (dblClicked) {
            this.submit();
        }
    }

    submit() {
        if (this.folderId !== this.originalFolderId) {
            this.folderChangedCallback(
                this.eventEmitter({
                    folderId: this.folderId
                })
            );
        }
        this.close();
    }

    close() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/common/folder-path-edit/dialog/dialog.controller.js